import { z } from 'zod';

/////////////////////////////////////////
// INSPECTIONS SCHEMA
/////////////////////////////////////////

export const InspectionsSchema = z.object({
  id: z.bigint(),
  inspections_types_id: z.bigint().nullable(),
  primary_location_id: z.number().int().nullable(),
  core_address_id: z.number().int().nullable(),
  title: z.string(),
  city_id: z.number().int(),
  status: z.string().nullable(),
  comment: z.string().nullable(),
  scheduled_at: z.coerce.date().nullable(),
  assignee_id: z.number().int().nullable(),
  applicant_id: z.number().int().nullable(),
  location: z.string().nullable(),
  inspectable_type: z.string().nullable(),
  inspectable_id: z.bigint().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  completed_at: z.coerce.date().nullable(),
  started_at: z.coerce.date().nullable(),
  record_id: z.number().int().nullable(),
  record_type: z.string().nullable(),
  record_name: z.string().nullable(),
  scheduled_date: z.coerce.date().nullable(),
  scheduled_time: z.coerce.date().nullable(),
  scheduled_meridiem: z.string().nullable(),
  scheduling_preferences_message: z.string().nullable(),
  parent_id: z.bigint().nullable(),
  on_site_contact_name: z.string().nullable(),
  on_site_contact_phone: z.string().nullable(),
  on_site_contact_instructions: z.string().nullable(),
  on_site_contact_applicant_instructions: z.string().nullable(),
  rowTimestamp: z.coerce.date(),
  request_rejected_date: z.coerce.date().nullable(),
  request_rejection_message: z.string().nullable(),
  unscheduled_email_last_sent_at: z.coerce.date().nullable(),
})

export type Inspections = z.infer<typeof InspectionsSchema>

export default InspectionsSchema;
